import React, { Component } from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { IntlProvider } from 'react-intl';
import { Route, Switch } from 'react-router-dom';
import CircularProgress from 'material-ui/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';

import MainApp from 'routes/app/';
import Page404 from 'routes/404/';
import AppLocale from 'lngProvider/';
import { toggleAlertError, logoutUser, openPhoneCallModal, hangUpCall } from 'stores/actions';
import APPCONFIG from 'constants/Config';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import 'react-select/dist/react-select.css';
import 'font-awesome/css/font-awesome.min.css';
import 'styles/bootstrap.scss';
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-datetime/css/react-datetime.css';

import lightTheme from './themes/lightTheme';
import websocket from "stores/reducers/common/websocket";
import WebsocketComp from "components/Websocket";

class App extends Component {
  constructor() {
    super();
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage ) {
      toast(
        <div>
          {nextProps.errorMessage}
          {nextProps.msgToCopy ?
            <CopyToClipboard text={nextProps.msgToCopy}>
              <button className="btn btn-warning btn-sm mx-1"><i className="fa fa-copy"/></button>
            </CopyToClipboard> : null
          }
        </div>, {
          onClose: ( props ) => this.props.toggleAlertError( '' ),
          autoClose: nextProps.msgToCopy ? false : 5000,
          closeOnClick: !nextProps.msgToCopy
        } )
    }
  }

  componentDidMount() {
    /*setTimeout( () => {
      this.callEvent( '12345' );
    }, 2000 );
    setTimeout( () => {
      this.props.hangUpCall()
    }, 6000 );*/
    new PresenceWebAgentIntegration( this.EventMessage.bind( this ) );
  }

  EventMessage( evt ) {
    console.log( 'EventMessage', evt );
    if( evt.Event === APPCONFIG.presenceInboundCallEvent ) {
      this.callEvent( evt.Phone );
    }
    if( evt.Event === APPCONFIG.presenceHangUpCallEvent ) {
      this.props.hangUpCall()
    }
  }

  callEvent( phone ) {
    if( this.props.location.pathname !== '/agent' ) {
      this.props.history.push( '/agent' );
    }
    this.props.openPhoneCallModal( phone )
  }

  render() {
    const { isLoading, user, locale, websocket } = this.props;
    const currentAppLocale = AppLocale[locale.locale];

    return (
      <MuiThemeProvider muiTheme={getMuiTheme( lightTheme )}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <div id="app-inner">
            <div className="full-height fixed-header">

              {isLoading ?
                <div className="app-loading">
                  <CircularProgress size={60} thickness={7}/>
                </div> : null
              }

              <ToastContainer
                position={toast.POSITION.TOP_RIGHT}
                toastClassName="dark-toast"
                progressClassName="transparent-progress"
                autoClose={5000}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
              />

              <Switch>
                <Route path="/" component={MainApp}/>
                <Route component={Page404}/>
              </Switch>
            </div>

            <WebsocketComp/>
          </div>
        </IntlProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  isLoading: state.settings.isLoading,
  errorMessage: state.settings.errorMessage,
  msgToCopy: state.settings.msgToCopy,
  user: state.user,
  locale: state.settings.locale,
} );

const mapDispatchToProps = dispatch => ( {
  logoutUser: () => {
    dispatch( logoutUser() );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  openPhoneCallModal: ( phone ) => {
    dispatch( openPhoneCallModal( phone ) );
  },
  hangUpCall: () => {
    dispatch( hangUpCall() );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( App );



// WEBPACK FOOTER //
// ./containers/App.js